/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const peoplePopup = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.peopleReadMore = document.getElementsByClassName('people-read-more');
    DOM.peoplePopup = document.getElementsByClassName('people-popup');
    DOM.close = document.getElementsByClassName('people-popup__close');

    DOM.lozengeOpen = document.getElementsByClassName('lozenge__title');
    DOM.lozengeContent = document.getElementsByClassName('lozenge__content');
    DOM.lozengeClose = document.getElementsByClassName('lozenge__close');


  };

  const openPopup = (event, i) => {
    event.preventDefault();
    DOM.peoplePopup[i].setAttribute('style', 'display: block');
  };

  const closePopup = (event, i) => {
    event.preventDefault();
    DOM.peoplePopup[i].removeAttribute('style');
  };

  const openPopupLoz = (event, i) => {
    event.preventDefault();
    DOM.lozengeContent[i].setAttribute('style', 'display: block');
  };

  const closePopupLoz = (event, i) => {
    event.preventDefault();
    DOM.lozengeContent[i].removeAttribute('style');
  };

  const eventListeners = () => {
    for (let i = 0; i < DOM.peopleReadMore.length; i++) {
      DOM.peopleReadMore[i].addEventListener('click', () => {
        openPopup(event, i)
      });
      DOM.close[i].addEventListener('click', () => {
        closePopup(event, i)
      });
    }

    for (let i = 0; i < DOM.lozengeOpen.length; i++) {
      DOM.lozengeOpen[i].addEventListener('click', () => {
        openPopupLoz(event, i)
      });
      DOM.lozengeClose[i].addEventListener('click', () => {
        closePopupLoz(event, i)
      });
    }
  };

  function init() {
    cacheDOM();
    eventListeners();
  }

  return {
    init
  };
})();

export default peoplePopup;
